import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { GlobalConstants } from 'src/app/common/global-constants';
import { NavigateAssociates } from 'src/app/helpers/navigate-associates';
import { NotificationService } from 'src/app/services/notification.service';
import { UtilsService } from 'src/app/services/utils.service';
import { DevTooltipCustComponent } from 'src/app/widgets';
import { OverviewFiltersOutput} from '../../stock/stock.service';
import { ForecastService } from '../forecast.service';

import { TaskService } from '../../task/task.service';
import { ShareDataService } from 'src/app/services/share-data.service';
import { HelpService } from '../../help/help.service';
import { FileExportService } from 'src/app/common/file-export-service';
import { DxChartComponent, DxDataGridComponent } from 'devextreme-angular';

import { TableParameterService } from 'src/app/services/table-parameter-service';
import { DxDataGridOperator } from 'src/app/operators/dx-data-grid.operator';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { FiltersOperator } from 'src/app/widgets/filters/api/filters-operator.api';
import { SelectStatementOptions } from 'src/app/models/select-statement-options.model';
import { BaseSelectStatementId } from 'src/app/enums/base-select-statement-id.enum';
import { SelectionSetId } from 'src/app/enums/selection-set-id.enum';
import { BookmarkNewComponent } from 'src/app/widgets/bookmark-new/bookmark-new.component';
import { ActivatedRoute, Data } from '@angular/router';
import { BookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/bookmark-elements.operator';
import { FiltersGroupBookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/filters-group-bookmark-elements.operator';

@Component({
	selector: 'app-activity-result',
	templateUrl: './activity-result.component.html',
	styleUrls: ['./activity-result.component.scss'],
	standalone: false
})
export class ActivityResultComponent implements OnInit {

	public filterOptions: OverviewFiltersOutput = new OverviewFiltersOutput();

	public activitiesResultsGridColumns: { columnName: string; caption: string }[] = [];
	public activitiesResultsGridData: any[] = [];

	// <Chart>

	public activitiesResultsChartColumns: { columnName: string; caption: string }[] = [];
	public activitiesResultsChartData: any[] = [];

	public visualRange: any = {};
	//dev express setting changes function for chart need on resize after windows size changes
	@ViewChild("forecastDevelopmentChart", { static: false }) dxforecastDevelopmentChart: DxChartComponent;
	@ViewChild('dataGrid', { static: false }) dataGrid: DxDataGridComponent;
	// </Chart>

	//Filters
	public pageFiltersOperator: FiltersOperator = new FiltersOperator(
		new SelectStatementOptions(
		  {
			filters: async () => this.pageFiltersOperator.appliedFilters,
	
			baseSelectStatementId: BaseSelectStatementId.ForecastActivitiesResultsGridData,
			selectionSetId: SelectionSetId.ForecastActivitiesResultsGridDataFilters,
		  }
		)
	);
	//Bookmark
	@ViewChild('bookmarksGroup', { static: false })
	public bookmarksGroup: BookmarkNewComponent;
	  
	private _activatedRoute: ActivatedRoute = inject(ActivatedRoute);
	public bookmarkElementsOperators: BookmarkElementsOperator[];
	
	public async initializeBookmarks(): Promise<Data> {
	let routeData: Data = await firstValueFrom(this._activatedRoute.data);
	
	this.bookmarkElementsOperators = [
		new FiltersGroupBookmarkElementsOperator(
		  {
			id: UtilsService.computeRouteHash(routeData.id, FiltersGroupBookmarkElementsOperator.DEFAULT_ID_PART).toString(),
			filtersOperator: () => this.pageFiltersOperator
		  }
		)
	];
	
	return routeData;
	}

	private readonly _componentTitle = "Activity Result";

	constructor(
		private titleService: Title,
		private helpService: HelpService,
		private notificationService: NotificationService,
		private shareDataService: ShareDataService,
		private forecastService: ForecastService,
		private taskService: TaskService,
		private navigates: NavigateAssociates,
		private fileExportService: FileExportService,
		private tableParamService: TableParameterService
	) {
		this.shareDataService.CleanData();
	}

	async ngOnInit() {
		this.titleService.setTitle(this._componentTitle);

		this.filterOptions.action = "Filter";
		this.loadLengendToShare();
		await this.initializeBookmarks();
    	this.loadPageData();
    	this.pageFiltersOperator.onFiltersApplied.subscribe(
      	 (selection) => {
         	this.shareDataService.CleanData();
         	this.shareDataService.filterOptionOverview = selection.output;
         	this.pageFiltersOperator.load(
         	  {
         	    showLoadingIndicator: true,
         	  }
         	);
		 	this.initializeActivitiesResultsChartData();
			this.initializeActivitiesResultsGridData();  	 
		}
    	);
		this.WebSettingsPivot();
	}

	public async loadPageData() {
		(await this.pageFiltersOperator.getObservable(
			{
				showLoadingIndicator: true,
			}
		)).subscribe(
			{
				next: async (_) => {
					if (!(await this.bookmarksGroup.applyDefaultBookmark())) {
						this.loadLengendToShare();
						this.initializeActivitiesResultsChartData();
						this.initializeActivitiesResultsGridData(); 
					}
				}
			}
		);
	}

	private initializeActivitiesResultsGridData() {
		const observable$ = this.forecastService.getActivitiesResultsGridData(
			this.filterOptions.action,
			this.filterOptions.filters,
			{
				showLoadingIndicator: true,
			}
		);

		return lastValueFrom(observable$).then(
			(response) => {


				this.activitiesResultsGridColumns = response.columns;
				this.activitiesResultsGridData = response.data;
			}
		);
	}

	// <Chart>

	public onLegendClickMainChart(e: any) {
		const series = e.target;
		if (series.isVisible()) {
			series.hide();
		} else {
			series.show();
		}
		this.loadLengendToShare();
	}

	public customizeTooltip = (info: any) => {
		return DevTooltipCustComponent.customizeTooltip(info, "", "", "");
	}

	public getMarkerPath(item) {
		return UtilsService.getlegendMarkerPathDynamic(item, 'deepdive', GlobalConstants.SvgLinSettingsCollection.defaultSettingsNew);
	}

	onToolbarPreparing(e: any) {
		e.toolbarOptions.items.unshift({
			location: "before",
			template: "columnMode",
		}, {
			location: 'before',
			template: 'heightButtonTemplate'
		});
	}

	compactMode = false;
	onToggleColumnsMode() {
		this.compactMode = !this.compactMode;


		let currentState = this.dataGrid.instance.state();
		currentState.columns.forEach(col => {
			delete col.width;
		});

		this.dataGrid.instance.state(currentState);
	}

	onDataGridCellPrepared(e) {
		e.cellElement.style.padding = '5px';
	}

	public dxDataGridOperator: DxDataGridOperator = new DxDataGridOperator();

	onDataGridContentReady(evt) {
		this.dxDataGridOperator.updateRowCount(evt.component);

		localStorage.setItem('grid-state-fc-activity-res', JSON.stringify(this.dataGrid.instance.state()));
	}

	private initializeActivitiesResultsChartData() {
		const observable$ = this.forecastService.getActivitiesResultsChartData(
			this.filterOptions.action,
			this.filterOptions.filters,
			{
				showLoadingIndicator: true,
			}
		);

		return lastValueFrom(observable$).then(
			(response) => {


				this.activitiesResultsChartColumns = response.columns;
				this.activitiesResultsChartData = response.data;

				this.LoadChartSeries();
			}
		);
	}

	// </Chart>

	changeProductId(item: any) {
		if (item != null && item.data != null && item.data.ForecastObjectClientId != null) {
			this.navigates.navigateTO('forecast/deep-dive-new?id=' + UtilsService.getURLHelper(item.data.ForecastObjectClientId));
		}
	}

	//tooltip
	EnableTooltip = false;
	ShowTooltip = false;
	WebSettingsPivot() {
		this.fileExportService.WebSettingsPivot("actionpivotForecastActivityResult").subscribe(result => {
			console.log(result);
			if (result != null && result.length > 0 && result[0].defaultSelectionTooltipForecastActivityResult != null
				&& result[0].defaultSelectionTooltipForecastActivityResult.toLowerCase() == "yes") {
				this.EnableTooltip = true;
			}
			if (result != null && result.length > 0 && result[0].enableDisableTooltipForecastActivityResult != null
				&& result[0].enableDisableTooltipForecastActivityResult.toLowerCase() == "yes") {
				this.ShowTooltip = true;
			}

		}, err => {
			console.log(err);
		});
	}


	loadLengendToShare() {

		let seriesValues = { ForecastDevelopmentChart: [] };
		if (this.dxforecastDevelopmentChart != null && this.dxforecastDevelopmentChart.instance != null
			&& this.dxforecastDevelopmentChart.instance.getAllSeries() != null) {
			this.dxforecastDevelopmentChart.instance.getAllSeries().forEach(item => {
				if (item.name != null && item["getValueFields"]() && item["getValueFields"]().length > 0) {
					seriesValues.ForecastDevelopmentChart.push({ ValueField: item["getValueFields"]()[0], Name: item.name, isVisible: item.isVisible() });
				}
			})
		}
		this.shareDataService.ChartSettings = JSON.stringify(seriesValues);
	}

	ChartSettings: any;
	LoadChartSeries() {
		if (Array.isArray(this.dxforecastDevelopmentChart.series)) {
			for (let index = 0; index < this.dxforecastDevelopmentChart.series.length; index++) {
				this.dxforecastDevelopmentChart.series[index].visible = true;
			}
		}
		if (this.ChartSettings != null) {
			if (this.ChartSettings.ForecastDevelopmentChart != null && this.ChartSettings.ForecastDevelopmentChart.length > 0) {
				if (this.dxforecastDevelopmentChart != null && this.dxforecastDevelopmentChart.series != null
					&& Array.isArray(this.dxforecastDevelopmentChart.series) && this.dxforecastDevelopmentChart.series.length > 0) {
					for (let index = 0; index < this.dxforecastDevelopmentChart.series.length; index++) {
						this.ChartSettings.ForecastDevelopmentChart.forEach(itemchrt => {
							if (this.dxforecastDevelopmentChart.series[index].valueField != null
								&& itemchrt.isVisible != null && (this.dxforecastDevelopmentChart.series[index].valueField.toLowerCase() == itemchrt.ValueField.toLowerCase()
									|| this.dxforecastDevelopmentChart.series[index].name.toLowerCase() == itemchrt.ValueField.toLowerCase())
							) {
								this.dxforecastDevelopmentChart.series[index].visible = itemchrt.isVisible;
							}
						});
					}
				}
			}
		}
		this.dxforecastDevelopmentChart.instance.refresh();
	}



}
